import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function AuthCallbackPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get('token');
    if (token) {
      localStorage.setItem('spa_token', token);
      localStorage.setItem('mh_token', token);
    }
    const redirect = params.get('redirect');
    navigate(redirect || '/dashboard', { replace: true });
  }, []);

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg-0)' }}>
      <div style={{ textAlign:'center' }}>
        <div style={{ width:40, height:40, background:'var(--gold)', borderRadius:12, display:'inline-flex', alignItems:'center', justifyContent:'center', fontFamily:"'Fraunces',serif", fontWeight:700, fontSize:20, color:'#080a0d', marginBottom:12 }}>M</div>
        <div style={{ fontSize:'0.85rem', color:'var(--t-muted)' }}>Connecting…</div>
      </div>
    </div>
  );
}
